const bullet = {
  textStyle: 'body.smallPrint.regular',
  color: 'neutrals.4',
  ml: [4, 5]
}

export default bullet
